import { render, staticRenderFns } from "./DraggablePostIt.vue?vue&type=template&id=74170f9c&scoped=true"
import script from "./DraggablePostIt.vue?vue&type=script&lang=js"
export * from "./DraggablePostIt.vue?vue&type=script&lang=js"
import style0 from "./DraggablePostIt.vue?vue&type=style&index=0&id=74170f9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74170f9c",
  null
  
)

export default component.exports